import { useState } from 'react';
import {
    BoltIcon,
    CalendarDaysIcon,
    CalendarIcon,
    ClockIcon,
    DocumentDuplicateIcon
} from '@heroicons/react/24/outline/index.js';

const IDEAS = [
    {
        label: 'Create a form',
        icon: <DocumentDuplicateIcon />,
        subideas: [
            'Create a form to collect client history',
            'Set up a waiver for clients to sign before appointments',
            'Create an appointment booking form which asks only new clients for their information',
        ],
    },
    {
        label: 'Event types',
        icon: <CalendarIcon />,
        subideas: [
            'Set up new event types for 30min, 60min, 90min appointments with pricing of $100/hour',
            'Increase the prices of all of my events by $5',
        ],
    },
    {
        label: 'Set availability',
        icon: <ClockIcon />,
        subideas: [
            'Set up availability for each of my staff members to 9am-5pm every weekday',
            "Set up availability for three therapists who share 1 room so we don't overbook",
            'Set up booking for a bus where we have 8 seats and run shuttles every 30 minutes',
        ],
    },
];

const NEW_BUSINESS_IDEAS = [
    {
        label: 'Set up Account',
        icon: <BoltIcon />,
        subideas: [
            'My website is https://example.com, set up my account based on that',
            'I offer Consultations that cost $100 for 30 minutes. I am available 9am-5pm every weekday.',
        ],
    },
];

const AssistantIdeas = ({ className, onSelect, hasPrompt, businessData }) => {
    const [selectedIdea, setSelectedIdea] = useState('');

    let allIdeas = IDEAS;
    // If the business was created <48 hours ago show the new business prompts
    if (businessData?.business?.created_at) {
        const createdDate = new Date(businessData?.business?.created_at);
        const now = new Date();
        const hoursDiff = (now - createdDate) / (1000 * 60 * 60);

        if (hoursDiff < 48) {
            allIdeas = [
                ...NEW_BUSINESS_IDEAS,
                ...IDEAS,
            ];
        }
    }

    let showIdeas = allIdeas.find(i => i.label === selectedIdea)?.subideas;
    let showingSubIdeas = true;
    if (!showIdeas) {
        showingSubIdeas = false;
        showIdeas = allIdeas;
    }

    function select(idea) {
        setSelectedIdea(idea);
        onSelect(idea);
    }

    return (
        <div className={className}>
            {!showingSubIdeas && (
                <div className="grid xs:grid-cols-2 md:grid-cols-4 gap-2 items-center">
                    {showIdeas.map((idea, idx) => (
                        <div
                            key={idx}
                            className="px-3 py-1.5 text-nowrap flex justify-center items-center cursor-pointer border text-sm text-gray-500 border-gray-300 rounded-full hover:border-primary-700 hover:text-primary-700"
                            onClick={() => select(idea.label)}
                        >
                            <div className="w-5 h-5 mr-2">{idea.icon}</div>
                            {idea.label}
                        </div>
                    ))}
                </div>
            )}
            {showingSubIdeas && (
                <div className="divide-y">
                    {showIdeas.map((idea, idx) => (
                        <div
                            key={idx}
                            className="cursor-pointer hover:bg-gray-100 p-3"
                            onClick={() => select(idea)}
                        >
                            {idea}...
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default AssistantIdeas;
